module.exports = __webpack_public_path__ + "img/part3-bg7.5fdbf09e.png";